import React, { useEffect } from 'react'
import GuestNavbar from '../../components/navigations/GuestNavbar'
import SupportPage from '../../components/Support/SupportPage'

export default function Support() {
  useEffect(()=>{ window.scrollTo(0,0); },[])
  return (
    <>
      <GuestNavbar />
      <SupportPage />
    </>
  )
}


